import './index.less'
import _searchResult from '@/assets/mock/searchResult.json'
import { Table } from 'antd'
import { searchResultI } from '..'
import { eye } from '@/assets/images/index'
import { useAppDispatch, useAppSelector } from '@/hooks'
import {
  setAnalysisImageId,
  setAnalysisWorkId
} from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import { getImagesOfWorkRequest } from '@/server'
import { useEffect, useState } from 'react'
import { SelectWorkList } from '@/components/SelectWorkList'
import { setSelectedPage } from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import * as d3 from 'd3'
import { ColumnsType } from 'antd/es/table'
interface TableViewTypeProps {
  setComponent: Function
}
//浏览页面
export function TableViewType(props: TableViewTypeProps) {
  const token = useAppSelector((state) => state.login.token)
  const dispatch = useAppDispatch()
  // 待选列表
  const [showWorkList, setShowWorkList] = useState<{ id: string; imageId: string; src: string }[]>(
    []
  )
  // 待选列表位置信息
  const [pos, setPos] = useState<number>(0)
  // 每张图的三角形icon是否展示
  const [iconArr, setIconArr] = useState<boolean[]>(Array(14).fill(false))

  const columns: ColumnsType<searchResultI> = [
    {
      title: '作品名称',
      dataIndex: 'workName',
      key: 'workName',
      width: '13%',
      ellipsis: true
    },
    {
      title: '作者',
      dataIndex: 'authorName',
      width: '9%',
      ellipsis: true,
      key: 'authorName'
    },
    {
      title: '朝代',
      dataIndex: 'dynasty',
      width: '8%',
      ellipsis: true,
      key: 'dynasty'
    },
    {
      title: '收藏机构',
      dataIndex: 'museum',
      width: '13%',
      ellipsis: true,
      key: 'museum'
    },
    {
      title: '材质',
      dataIndex: 'mediaType',
      width: '6%',
      ellipsis: true,
      key: 'mediaType'
    },
    {
      title: '设色',
      dataIndex: 'materialType',
      width: '6%',
      ellipsis: true,
      key: 'materialType'
    },
    {
      title: '形制',
      dataIndex: 'styleType',
      width: '6%',
      ellipsis: true,
      key: 'styleType'
    },
    {
      title: '主题',
      dataIndex: 'class1',
      width: '6%',
      ellipsis: true,
      key: 'class1'
    },
    {
      title: '类型',
      dataIndex: 'class2',
      width: '8%',
      ellipsis: true,
      key: 'class2'
    },
    {
      title: '宽/cm',
      dataIndex: 'horizontal',
      width: '6%',
      ellipsis: true,
      key: 'horizontal'
    },
    {
      title: '高/cm',
      dataIndex: 'vertical',
      width: '6%',
      key: 'vertical'
    },
    {
      title: '查看',
      key: '查看',
      width: '6%',
      render: (_, record, index) => (
        <div className='operate-icon'>
          <div className='tri-icon' style={{ display: iconArr[index] ? 'block' : 'none' }}></div>
          <img src={eye} onClick={(e) => handleSelectItem(e, record, index)} alt='查看' />
        </div>
      )
    }
  ]
  //画作列表
  const data: searchResultI[] = useAppSelector((state) => state.overviewTypeList.overviewList)
  const { setComponent } = props
  //画作列表中，画作鼠标点击事件
  const handleSelectItem = function (e, record, index) {
    const id = record.workId
    dispatch(setSelectedPage(0))

    getImagesOfWorkRequest({ workId: id }, token).then((res) => {
      const list = res.data.content.map((work) => {
        return {
          id,
          imageId: work.imageid,
          src: work.fullpath
        }
      })
      if (list.length === 1) {
        dispatch(setAnalysisWorkId(id))
        dispatch(setAnalysisImageId(list[0].imageId))
        setComponent(2)
      } else {
        d3.select('#select-work-list').style('display', 'flex')
        setShowWorkList(list)
        setIconArr(
          iconArr.map((_icon, i) => {
            if (i === index) return true
            else return false
          })
        )
        // 待选列表位置设置
        const topPos = e.target.parentNode.parentNode.offsetTop
        const nodeHeight = (d3.select('#select-work-list')?.node() as any).clientHeight
        const tableHeight = (d3.select('#table-view-container')?.node() as any).clientHeight
        if (nodeHeight > 2 * topPos) {
          setPos(nodeHeight / 2)
        } else if (2 * topPos + nodeHeight > 2 * tableHeight) setPos(tableHeight - nodeHeight / 2)
        else setPos(topPos)
      }
    })
  }
  useEffect(() => {
    const func = (e: any) => {
      const selectWorkListDiv = document.querySelector('#select-work-list')
      if (selectWorkListDiv && !selectWorkListDiv.contains(e.target)) {
        d3.select('#select-work-list').style('display', 'none')
        setShowWorkList([])
        setIconArr(Array(14).fill(false))
      }
    }
    document.addEventListener('mousedown', func)
    return () => {
      document.removeEventListener('mousedown', func)
    }
  })
  return (
    <div className='table-view-container' id='table-view-container'>
      <Table columns={columns} dataSource={data} pagination={false} />
      <div
        className='select-work-list'
        id='select-work-list'
        style={{
          display: showWorkList.length > 1 ? 'flex' : 'none',
          top: pos + 'px',
          transform: 'translate(0, -50%)'
        }}
      >
        <SelectWorkList
          showWorkList={showWorkList}
          listSize={4}
          setComponent={props.setComponent}
          type={1}
        />
      </div>
    </div>
  )
}
